const searchInput = document.querySelector(".search-field");
const clearBtn = document.getElementById("clear-btn");
if (searchInput) {
  searchInput.addEventListener("input", () => {
    if (searchInput.value.length > 0) {
      clearBtn.style.display = "block";
    } else {
      clearBtn.style.display = "none";
    }
  });

  clearBtn.addEventListener("click", () => {
    searchInput.value = "";
    clearBtn.style.display = "none";
    searchInput.focus();
  });
}
